import script from "./Login.vue3.vue?vue&type=script&setup=true&lang=ts"
export * from "./Login.vue3.vue?vue&type=script&setup=true&lang=ts"

import "./Login.vue3.vue?vue&type=style&index=0&id=c3986848&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3986848"]])

export default __exports__